import React from 'react';
import { BaseLayerView } from '@/framework';
import { IRenderLayerProps } from '@/version-types';
import QRCodeLayerContent from './layer-content';

const QrCodeLayer: React.FC<IRenderLayerProps> = ({ layer, isNavigator }) => {
    return (
        <BaseLayerView layer={layer} isNavigator={isNavigator}>
            <QRCodeLayerContent layer={layer} />
        </BaseLayerView>
    );
};
export default React.memo(QrCodeLayer);
